/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DevicesImportControllerExportCsvStatusItem =
  (typeof DevicesImportControllerExportCsvStatusItem)[keyof typeof DevicesImportControllerExportCsvStatusItem];

export const DevicesImportControllerExportCsvStatusItem = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  DEACTIVATED: 'deactivated',
  ARCHIVED: 'archived',
  UNPLUGGED: 'unplugged',
} as const;
